var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "550px" },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [
              _vm._v("Deprecate Config"),
            ]),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4", md: "4" } },
                    [
                      _c("r-item-deprecate-mode", {
                        attrs: { model: _vm.mode },
                        on: {
                          "update:model": function ($event) {
                            _vm.mode = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "pt-5",
                      attrs: { cols: "12", sm: "4", md: "4" },
                    },
                    [
                      _c("v-checkbox", {
                        staticClass: "mx-1 mt-0",
                        attrs: { label: "Silent Mode", "hide-details": "" },
                        model: {
                          value: _vm.model.silent,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "silent", $$v)
                          },
                          expression: "model.silent",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "pt-4", attrs: { dense: "" } },
                [
                  _c(
                    "v-expansion-panels",
                    {
                      model: {
                        value: _vm.panels,
                        callback: function ($$v) {
                          _vm.panels = $$v
                        },
                        expression: "panels",
                      },
                    },
                    [
                      _vm.mode.id === 2
                        ? _c(
                            "r-panel",
                            { attrs: { title: "Config" } },
                            [
                              _c(
                                "v-row",
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "4", sm: "4" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Overflow:",
                                          "hide-details": "",
                                        },
                                        model: {
                                          value: _vm.model.overflow,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.model,
                                              "overflow",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "model.overflow",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm.mode.id === 4
                        ? _c(
                            "r-panel",
                            { attrs: { title: "Config" } },
                            [
                              _c(
                                "v-row",
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "4", sm: "4" } },
                                    [
                                      _c("r-range", {
                                        attrs: {
                                          model: _vm.model.lifetime,
                                          label: "LifeTime",
                                        },
                                        on: {
                                          "update:model": function ($event) {
                                            return _vm.$set(
                                              _vm.model,
                                              "lifetime",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("r-guard-panel", {
                        attrs: {
                          hidden: _vm.mode.id !== 2,
                          model: _vm.model.guard,
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "guard", $event)
                          },
                        },
                      }),
                      _c("r-reward-panel", {
                        attrs: {
                          disabled: _vm.mode.id === 0,
                          model: _vm.model.reward,
                          title: "Rewards",
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "reward", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v("Save")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }